import React from 'react';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import './RamaSwamySection.css';
import parse from "html-react-parser";

const InterviewBanner = ({ webpageData }) => {
  const interviewBannerData = webpageData?.interviewBannerData || {};
  const imgCDNURL = process.env.REACT_APP_CDN_LINK + "ussaic/";

  return (
    <div className="interview-banner">
      <div className="ramaswamy-bg">
      <div className="play-button-overlay">
      <a
    href="https://www.youtube.com/live/NzYzgIc65HM?si=sAM9we2-Fn1kFdm6"
    target="_blank"
    rel="noopener noreferrer"
  >
  <img
    src={imgCDNURL + "play-button-icon.webp"}
    alt="Play"
    className="play-button-icon"
  />
  </a>
</div>
        <Container>
          <Row className="align-items-center">
            <Col lg={6}>
              <div className="content-section">
                <h1 className="banner-title">

                  {/* <span className="highlight">{parse(interviewBannerData.interviewHighlight || "")} </span><br />{parse(interviewBannerData.interviewTitle || "")} <br />{parse(interviewBannerData.interviewHighlight || "")} */}

                  <span className="highlight">Featured Moment: </span><br />{parse(interviewBannerData.interviewTitle || "")} <br />{parse(interviewBannerData.interviewHighlight || "")}
                </h1>
                <p className="banner-description">
                  {/* {parse(interviewBannerData.interviewDescription || "")} */}

                  In a candid and inspiring conversation, Vivek Ramaswamy shared his bold vision for the future of Ohio, discussing the critical role of Ai, blockchain, and workforce transformation in reshaping both the state and the nation. His passion for embracing new technologies, coupled with his unwavering belief in Ohio’s potential, was a highlight that sparked powerful conversations across the room.
                </p>
              </div>



              <div className="personram-info-desktop">
                <div className="personram-info">
                  <h3 className="personram-name">{parse(interviewBannerData.interviewName || "")}</h3>
                  <p className="personram-title">{parse(interviewBannerData.interviewTitleText || "")}</p>

                </div>
              </div>





            </Col>

            <Col lg={6}>
              <div className="image-section">
                <div className="personram-card">
                  <div className="personram-image">
                    <img
                      src={imgCDNURL + "Vivek-Ramaswamy.webp"}
                      alt="Vivek Ramaswamy"
                      className="img-fluid"
                    />

                    <img
                      src={imgCDNURL + "Pavan-Agarwal.webp"}
                      alt="Pavan Agarwal"
                      className="img-fluid pavanimagechangesdesktop"
                    />
                  </div>
                </div>
              </div>





              {/* <div className="personram-info-mobile">
                <div className="personram-info">
                  <h3 className="personram-name">{parse(interviewBannerData.interviewName || "")}</h3>
                  <p className="personram-title">{parse(interviewBannerData.interviewTitleText || "")}</p>
                  <p className="personram-title-mobile">{parse(interviewBannerData.interviewTitleTextMobile || "")}</p>
                </div>
              </div> */}


              {/* <img
                src={imgCDNURL + "Pavan-Agarwal-mobile.webp"}
                alt="Pavan Agarwal"
                className="img-fluid pavanimagechangesmobile"
              /> */}




              <div className="personpavan-info-desktop">
                <div className="pavannamechanges-info">
                  <h3 className="pavannamechanges-name "><a className="custom-link" href="https://www.swmc.com/pavan" rel='noreferrer noopener' target='_blank'>Pavan Agarwal</a></h3>
                  <p className="pavannamechanges-title custom-link">CEO of <a href="https://www.swmc.com/" rel='noreferrer noopener' target='_blank'>Sun West</a> and Creator of <a href="https://www.swmc.com/angelai" rel='noreferrer noopener' target='_blank'>AngelAi</a></p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>


        
        <div className="speaker-card-mobile">
          <img
            src={imgCDNURL + "Vivek-Ramaswamy-mobile.webp"}
            alt="Vivek Ramaswamy"
            className="speaker-image-mobile"
            loading="lazy"
          />
          <div className="speaker-info-strip">
            <h3 className="speaker-name-mobile">Vivek Ramaswamy</h3>
            <p className="speaker-title-mobile">Entrepreneur and Politician</p>
          </div>
        </div>

        <div className="speaker-card-mobile mt-5">
          <img
            src={imgCDNURL + "Pavan-Agarwal-mobile.webp"}
            alt="Pavan Agarwal"
            className="speaker-image-mobilepavan"
            loading="lazy"
          />
          <div className="speaker-info-strip">
            <h3 className="speaker-name-mobile"><a className="custom-link" href="https://www.swmc.com/pavan" rel='noreferrer noopener' target='_blank'>Pavan Agarwal</a></h3>
            <p className="speaker-title-mobile custom-link">CEO of <a href="https://www.swmc.com/" rel='noreferrer noopener' target='_blank'>Sun West</a> and <br/>Creator of <a href="https://www.swmc.com/angelai" rel='noreferrer noopener' target='_blank'>AngelAi</a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InterviewBanner;
